import React from 'react';
import {
  Title,
  Container,
  ApiKeysContainer,
  StyledButton,
  Description,
} from './StandaloneAPIKeysPage.styles';
import { ThemeProvider } from 'styled-components';
import useAPIKeys from '../../hooks/useAPIKeys';
import { useAuth } from '../../hooks/useAuth';
import { useConfig } from '../../hooks/useConfig';
import ClientProvider from '../../hooks/useClient';
import { APIKeys } from '../../components/APIKeys/APIKeys';
import { darkColors } from '@hud/web-components/theme/colors';
import { HudIcon } from '@hud/web-components/Icons/HudIcons';
import Skeleton from '@hud/web-components/Skeleton/Skeleton';
import { useNavigate } from 'react-router-dom';
import usePlugSDK from '../../hooks/usePlugSDK';
import { ContactUsLink } from '../../components/ContactUsLink/ContactUsLink';

// Create a separate component that uses hooks dependent on ClientProvider
const AuthenticatedContent = () => {
  const { data, isLoading } = useAPIKeys();
  const navigate = useNavigate();
  usePlugSDK();

  return (
    <>
      <StyledButton
        variant="text"
        onClick={() => {
          navigate('/setup');
        }}
      >
        ← Back to installation guide
      </StyledButton>
      <Container>
        <HudIcon icon="menu.hud" width="70px" height="24px" />
        <Title>API Keys</Title>
        <ApiKeysContainer>
          {isLoading ? (
            <Skeleton width={300} />
          ) : data?.apiKeys && data.apiKeys.length > 0 ? (
            <APIKeys keys={data?.apiKeys || []} />
          ) : (
            <Description>
              Need help?{' '}
              <ContactUsLink startConversationContent="Hi! I need another API Key.">
                Chat with our support team
              </ContactUsLink>{' '}
              or email us at support@hud.io.
            </Description>
          )}
        </ApiKeysContainer>
      </Container>
    </>
  );
};

export default function StandaloneAPIKeysPage() {
  const { isLoading, token } = useAuth();
  const config = useConfig();

  return isLoading || !token ? ( // prevent flashing
    <ThemeProvider theme={darkColors}>
      <div></div>
    </ThemeProvider>
  ) : (
    <ClientProvider
      url={config.API_BASE_URL}
      detectionServiceUrl={config.DETECTION_SERVICE_URL}
      token={token}
    >
      <AuthenticatedContent />
    </ClientProvider>
  );
}
